import { render, staticRenderFns } from "./EmployeesLeaves.vue?vue&type=template&id=0225ba0a"
import script from "./EmployeesLeaves.vue?vue&type=script&lang=js"
export * from "./EmployeesLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports